import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c504478"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "p-9 h-100"
}
const _hoisted_2 = { class: "d-flex justify-content-end mb-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { style: {"position":"absolute","width":"100%","top":"-10000px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { style: {"color":"red"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { style: {"position":"absolute","width":"100%"} }
const _hoisted_18 = {
  colspan: "2",
  style: {"text-align":"center","font-weight":"bold"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"10px 0"} }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"10px 0"} }, null, -1))
const _hoisted_23 = {
  colspan: "2",
  style: {"text-align":"center","font-weight":"bold"}
}
const _hoisted_24 = { style: {"text-align":"center","font-weight":"bold"} }
const _hoisted_25 = { style: {"text-align":"center","font-weight":"bold"} }

import { ref, computed, inject, nextTick } from "vue";
import phonesData from "@/core/data/phonesData";
import SimpleForm from "@/components/SimpleForm.vue";
import { useI18n } from "vue-i18n";
import Clipboard, { copy } from "clipboard";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import BalanceShow from "@/components/BalanceShow.vue";
import { useStore } from "@/store";
import TimeShow from "@/components/TimeShow.vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import { TransactionAccountTypes } from "@/core/types/AccountInfos";

import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import PaymentMethodDefault from "../components/PaymentMethodDefault.vue";
import PaymentMethodJP from "../components/PaymentMethodJP.vue";
import PaymentMethodUSDT from "../components/PaymentMethodUSDT.vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawInfo',
  props: {
    fromDealing: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const withdrawId = ref(0);
const isLoading = ref(true);
const formRef = ref<InstanceType<typeof SimpleForm> | null>(null);
const wireForm = ref<any>({});
const store = useStore();
const user = store.state.AuthModule.user;
const t = useI18n().t;
const openConfirmBox = inject<any>(InjectKeys.OPEN_CONFIRM_MODAL);

const openConfirmPanel = () => {
  const _handler = () =>
    PaymentService.createOFA({
      id: withdrawId.value,
    });

  openConfirmBox(async () => {
    try {
      await _handler().then(() => MsgPrompt.success());
    } catch (error) {
      MsgPrompt.error(error);
    }
  });
};

const show = async (_item: any) => {
  isLoading.value = true;
  formRef.value?.show();

  const fromCurrencyId = _item.currencyId;

  const source = _item.source;
  withdrawId.value = _item.id;

  const withdrawalInfo: any = await PaymentService.getWithdrawalInfosById(
    _item.id
  );

  const res = await AccountService.queryAccounts({
    partyId: _item.partyId,
    hasTradeAccount: true,
  });

  const accountInfo =
    res.data.find(
      (x) =>
        x.tradeAccount && x.tradeAccount.accountNumber == source.displayNumber
    ) ?? {};

  const userTradeAccounts = res.data.map((x) => x.tradeAccount);

  wireForm.value = {
    refId: _item.payment.id,
    createdOn: _item.createdOn,
    status: _item.payment.status,
    amount: _item.amount,
    fee: "0",
    user: {
      name:
        _item.displayName || `${_item.user?.firstName} ${_item.user?.lastName}`,
      nativeName: _item.user?.nativeName,
      email: _item.user?.email,
      currency: _item.currencyId,
      balance: _item.source.balance,
      balanceInCents: _item.source.balanceInCents,
    },
    payment: _item.payment,
    // bankInfo: _item.supplements.Withdraw.Reference.Request,
    bankInfo: withdrawalInfo.Reference.Request,
    fromCurrencyId,
    toCurrencyId: withdrawalInfo.TargetCurrencyId,
    userTradeAccounts,
    exchangeRate: withdrawalInfo.ExchangeRate,
    accountInfo,
    source,
  };

  isLoading.value = false;
};

const copyTable = ref<HTMLDivElement | null>(null);

function toEmailNode(el: HTMLElement): HTMLElement {
  const clone = el.cloneNode(true) as HTMLElement;

  clone.querySelectorAll("input, textarea, select").forEach((node) => {
    let value = "";
    let tag: "span" | "div" = "span";

    if (node.tagName === "TEXTAREA") {
      value = (node as HTMLTextAreaElement).value;
      tag = "div"; // 多行显示更自然
    } else if (node.tagName === "SELECT") {
      const sel = node as HTMLSelectElement;
      value = Array.from(sel.selectedOptions)
        .map((o) => o.text)
        .join(", ");
    } else {
      const input = node as HTMLInputElement;
      switch ((input.type || "text").toLowerCase()) {
        case "checkbox":
          value = input.checked ? "☑" : "☐";
          break;
        case "radio":
          value = input.checked ? "◉" : "○";
          break;
        default:
          value = input.value;
      }
    }

    const span = document.createElement(tag);
    span.textContent = value;
    span.style.whiteSpace = "pre-wrap";
    // 尽量避免布局跳变
    try {
      const cs = getComputedStyle(node as Element);
      if (cs.width && cs.width !== "auto") span.style.minWidth = cs.width;
    } catch {
      console.log("Failed to getComputedStyle");
    }
    (node as Element).replaceWith(span);
  });

  return clone;
}

const copyPaymentInfo = () => {
  if (!copyTable.value) {
    MsgPrompt.error("Copy failed");
    return;
  }
  const node = toEmailNode(copyTable.value);
  // copyTable.value.removeChild(copyTable.value.firstChild!);
  copyTable.value.innerHTML = node.innerHTML;
  Clipboard.copy(copyTable.value);
  MsgPrompt.success("Copy success");
  window.getSelection()?.removeAllRanges();
  return;
};

const hide = () => {
  formRef.value?.hide();
};



const paymentMethodData = computed(() => {
  if (wireForm.value.bankInfo.walletAddress) {
    return {
      component: PaymentMethodUSDT,
      props: { wireForm: wireForm.value, phonesData },
    };
  } else if (wireForm.value.bankInfo.bankCountry.toLowerCase() === "jp") {
    // STIC
    if (wireForm.value.payment.paymentServiceId === 10107) {
      return {
        component: PaymentMethodJP,
        props: {
          withdrawId: withdrawId.value,
          wireForm: wireForm.value,
          phonesData,
          stic: true,
          fromDealing: props.fromDealing,
        },
      };
    } else {
      return {
        component: PaymentMethodJP,
        props: {
          withdrawId: withdrawId.value,
          wireForm: wireForm.value,
          phonesData,
          stic: false,
          fromDealing: props.fromDealing,
        },
      };
    }
  } else {
    return {
      component: PaymentMethodDefault,
      props: { wireForm: wireForm.value, phonesData },
    };
  }
});

__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "formRef",
    ref: formRef,
    "is-loading": isLoading.value,
    title: _ctx.$t('fields.paymentInfo'),
    "save-title": _ctx.$t('action.copy'),
    submit: copyPaymentInfo,
    "discard-title": _ctx.$t('action.close'),
    "min-height": 775
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingCentralBox, {
            key: 0,
            class: "h-100"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "btn btn-light btn-danger btn-sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openConfirmPanel())),
                disabled: isLoading.value
              }, " Create OFA ", 8, _hoisted_3)
            ]),
            _createElementVNode("div", {
              class: "",
              ref_key: "copyTable",
              ref: copyTable,
              style: {"position":"relative","height":"720px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(" Dear Tony: "),
                _hoisted_5,
                _createTextVNode(" This is " + _toDisplayString(wireForm.value.user.name) + "(" + _toDisplayString(wireForm.value.user.nativeName) + ")'s Withdrawal request form, the system has been updated. Please find the attached file. ", 1),
                _hoisted_6,
                _createElementVNode("b", null, [
                  _createTextVNode("Withdrawal Amount (Platform): "),
                  _createVNode(BalanceShow, {
                    balance: wireForm.value.amount,
                    "currency-id": wireForm.value.fromCurrencyId
                  }, null, 8, ["balance", "currency-id"]),
                  _hoisted_7,
                  _createTextVNode(" Rate: " + _toDisplayString(wireForm.value.exchangeRate), 1),
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode("Withdrawal Amount (Actual): "),
                    _createVNode(BalanceShow, {
                      balance: wireForm.value.amount * wireForm.value.exchangeRate,
                      "currency-id": wireForm.value.toCurrencyId
                    }, null, 8, ["balance", "currency-id"])
                  ])
                ]),
                _hoisted_10,
                _hoisted_11,
                _createTextVNode(" Please check it. Thanks. "),
                _hoisted_12,
                _hoisted_13,
                _createTextVNode(" Regards,"),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_unref(user).name) + " ", 1),
                _hoisted_15,
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t("title.withdrawInfo")), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                    _createElementVNode("td", null, [
                      _createVNode(TimeShow, {
                        "date-iso-string": wireForm.value.createdOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.paymentStatus.${wireForm.value.status}`)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.refId")), 1),
                    _createElementVNode("td", null, _toDisplayString(wireForm.value.refId), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.nativeName")), 1),
                    _createElementVNode("td", null, _toDisplayString(wireForm.value.user.nativeName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.email")), 1),
                    _createElementVNode("td", null, _toDisplayString(wireForm.value.user.email), 1)
                  ]),
                  (
                wireForm.value.source.accountType ===
                _unref(TransactionAccountTypes).TradeAccount
              )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
                          _createElementVNode("td", null, _toDisplayString(wireForm.value.source.displayNumber), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.salesCode")), 1),
                          _createElementVNode("td", null, _toDisplayString(wireForm.value.accountInfo.code), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.ibGroup")), 1),
                          _createElementVNode("td", null, _toDisplayString(wireForm.value.accountInfo.group), 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      (
                    wireForm.value.source.accountType ===
                    _unref(TransactionAccountTypes).Wallet
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("fields.walletBalance")), 1))
                        : (
                    wireForm.value.source.accountType ===
                    _unref(TransactionAccountTypes).TradeAccount
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("fields.accountBalance")), 1))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(BalanceShow, {
                        "currency-id": wireForm.value.user.currency,
                        balance: wireForm.value.user.balanceInCents
                      }, null, 8, ["currency-id", "balance"]),
                      _createTextVNode(" ( " + _toDisplayString(_ctx.$t("type.currency." + wireForm.value.user.currency)) + " ) ", 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.withdrawAmount")), 1),
                    _createElementVNode("td", null, [
                      _createVNode(BalanceShow, {
                        "currency-id": wireForm.value.fromCurrencyId,
                        balance: wireForm.value.amount
                      }, null, 8, ["currency-id", "balance"]),
                      _createTextVNode(" ( " + _toDisplayString(_ctx.$t("type.currency." + wireForm.value.fromCurrencyId)) + " ) ", 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.exchangeRate")), 1),
                    _createElementVNode("td", null, _toDisplayString(wireForm.value.exchangeRate), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.actualAmount")), 1),
                    _createElementVNode("td", null, [
                      _createVNode(BalanceShow, {
                        "currency-id": wireForm.value.toCurrencyId,
                        balance: wireForm.value.amount * wireForm.value.exchangeRate
                      }, null, 8, ["currency-id", "balance"]),
                      _createTextVNode(" ( " + _toDisplayString(_ctx.$t("type.currency." + wireForm.value.toCurrencyId)) + " ) ", 1)
                    ])
                  ])
                ]),
                _hoisted_21,
                _createElementVNode("div", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(paymentMethodData.value.component), _normalizeProps(_guardReactiveProps(paymentMethodData.value.props)), null, 16))
                ]),
                _hoisted_22,
                _createElementVNode("table", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.$t("title.userAccounts")), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$t("fields.balance")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wireForm.value.userTradeAccounts, (acc, idx) => {
                    return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                      _createElementVNode("td", null, _toDisplayString(acc.accountNumber), 1),
                      _createElementVNode("td", null, [
                        _createVNode(BalanceShow, {
                          "currency-id": acc.currencyId,
                          balance: acc.balance
                        }, null, 8, ["currency-id", "balance"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ], 512)
          ]))
    ]),
    _: 1
  }, 8, ["is-loading", "title", "save-title", "discard-title"]))
}
}

})